import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import TouchButton from "../../atoms/TouchButton/TouchButton";
import InputSelect from "../../atoms/InputSelect/InputSelect";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Eleventh = ({ formData, setFormData, onValidationChange, mode = 'wizard' }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(formData.activity_level !== undefined);
  }, [formData.activity_level, onValidationChange]);

  if (mode === 'validation') {
    return (
      <InputSelect
        label={t("animalInfo:QUESTION_ELEVEN.EXIT_FREQUENCY")}
        datas={[
          { value: 0, label: t("animalInfo:QUESTION_ELEVEN.RARELY") },
          { value: 33, label: t("animalInfo:QUESTION_ELEVEN.MOSTLY") },
          { value: 66, label: t("animalInfo:QUESTION_ELEVEN.OFTEN") },
          { value: 100, label: t("animalInfo:QUESTION_ELEVEN.EVERYTIME") },
        ]}
        value={formData.activity_level?.toString() ?? ""}
        onChange={(event) => setFormData({ 
          ...formData, 
          activity_level: parseInt(event.target.value.toString()) 
        })}
      />
    );
  }

  return (
    <>
      <TouchButton
        text={t("animalInfo:QUESTION_ELEVEN.RARELY")}
        active={formData?.activity_level === 0}
        onClick={() => {
          setFormData({ ...formData, activity_level: 0 });
        }}
      />
      <TouchButton
        text={t("animalInfo:QUESTION_ELEVEN.MOSTLY")}
        active={formData?.activity_level === 33}
        onClick={() => {
          setFormData({ ...formData, activity_level: 33 });
        }}
      />
      <TouchButton
        text={t("animalInfo:QUESTION_ELEVEN.OFTEN")}
        active={formData?.activity_level === 66}
        onClick={() => {
          setFormData({ ...formData, activity_level: 66 });
        }}
      />
      <TouchButton
        text={t("animalInfo:QUESTION_ELEVEN.EVERYTIME")}
        active={formData?.activity_level === 100}
        onClick={() => {
          setFormData({ ...formData, activity_level: 100 });
        }}
      />
    </>
  );
};

export default Eleventh;